<template>
  <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; flex-flow: column">
    <div class="d-flex flex-wrap justify-center align-center">
      <v-img src="../assets/ole.png" max-width="50" max-height="50"></v-img>
      <h2 class="pl-1" style="color: #f2a300">Olè Natural Medical Skin</h2>
    </div>
    <h1 style="text-align: center">多謝你</h1>
    <h2 style="text-align: center">已成功預約試做項目: {{ user.trial }}</h2>
    <h2>電話號碼: {{ user.phone }}</h2>
    <h2>你的預約號碼是：{{ user.token }}</h2>
    <a class="pa-3" :href="`https://wa.me/+85255155157?text=你好，我已成功預約: ${user.trial}，預約號碼: ${user.token}，我想了解更多關於療程資訊。` " target="_blank" style="text-decoration: none; color: black; font-size: 20px;">
      <div class="d-flex align-center">
        <v-img src="../assets/wtsapp.png" max-width="50" max-height="50"></v-img>
        即時對話
      </div>
    </a>
    <div class="d-flex flex-column align-center justify-center">
      <img :src="'https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl='+encodeURIComponent(user.phone+'|'+user.token)+'&choe=UTF-8'" alt="">
      <span>到場請出示此QR Code</span>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name     : "displayToken",
  computed : {
    ...mapState(['user'])
  }

}
</script>

<style scoped>

</style>
